import React from 'react';
import { useParams } from 'react-router-dom';
import CategoryPageRefactored from './CategoryPageRefactored';

const CategoryWrapper = () => {
  const { categoryName } = useParams();
  
  return <CategoryPageRefactored categorySlug={categoryName} />;
};

export default CategoryWrapper;
